import React, { useState, useEffect } from "react";
import { Line, Bar } from "react-chartjs-2";
import { fetchDailyData } from "../../api";

import styles from "./Chart.module.css";

const Chart = ({ basicData: { confirmed, recovered, deaths }, country }) => {
  const [dailyData, setDailyData] = useState([]);

  const getDailyData = async () => {
    setDailyData(await fetchDailyData());
  };

  useEffect(() => {
    getDailyData();
  }, []);

  const lineChart = dailyData.length ? (
    <Line
      options={{
        scales: {
          yAxes: [
            {
              gridLines: {
                color: "#4ECCA3",
                lineWidth: 2,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                color: "#4ECCA3",
                lineWidth: 1,
              },
            },
          ],
        },
      }}
      data={{
        labels: dailyData.map(({ date }) => date),
        datasets: [
          {
            data: dailyData.map(({ confirmed }) => confirmed),
            label: "Infected",
            borderColor: "#3333ff",
            fill: true,
          },
          {
            data: dailyData.map(({ deaths }) => deaths),
            label: "Deaths",
            borderColor: "red",
            backgroundColor: "rgb(255,0,0,0.5)",
            fill: true,
          },
        ],
      }}
    />
  ) : null;

  const barChart = confirmed ? (
    <Bar
      options={{
        scales: {
          yAxes: [
            {
              gridLines: {
                color: "#4ECCA3",
                lineWidth: 2,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                color: "#4ECCA3",
                lineWidth: 1,
              },
            },
          ],
        },
        legend: { display: false },
        title: { display: true, text: `Current situation in ${country}` },
      }}
      data={{
        labels: ["Infected", "Recovered", "Deaths"],
        datasets: [
          {
            label: "People",
            backgroundColor: [
              "rgba(0,0,255,0.5)",
              "rgba(0,255,0,0.5)",
              "rgba(255,0,0,0.5)",
            ],
            data: [confirmed.value, recovered.value, deaths.value],
          },
        ],
      }}
    />
  ) : (
    "loading..."
  );

  return (
    <div className={styles.container}>{country ? barChart : lineChart}</div>
  );
};

export default Chart;
